// export const MOCK_DATA_CAMPAIGNS = [
//   {
//     id: 503397, // data._campaignid in /api/Campaign/GetCampaigns
//     name: 'Candy Crush Saga - Ongoing', // campaign.campaign in /api/Campaign/GetCampaigns
//     image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
//     status: 2,
//     Installs: 16720,
//     Cost: 20,
//     trends: {
//       Installs: 'up',
//       Cost: 'down',
//     },
//   },
//   {
//     id: 503398,
//     name: 'Gardenscapes',
//     image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
//     status: '1',
//     Installs: 14280,
//     Cost: 210,
//     trends: {
//       Installs: 'up',
//       Cost: 'up',
//     },
//   },
//   {
//     id: 503399,
//     name: 'Township',
//     image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
//     status: '1',
//     Installs: 18840,
//     Cost: 20,
//     trends: {
//       Installs: '',
//       Cost: 'up',
//     },
//   },
//   {
//     id: 503400,
//     name: "Lily's Garden",
//     image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
//     status: '1',
//     Installs: 11920,
//     Cost: 10,
//     trends: {
//       Installs: 'up',
//       Cost: 'down',
//     },
//   },
//   {
//     id: 503401,
//     name: 'Beauty Empire',
//     image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
//     status: '1',
//     Installs: 15650,
//     Cost: 190,
//     trends: {
//       Installs: 'up',
//       Cost: '',
//     },
//   },
// ];

export const MOCK_DATA_APPLICATIONS = [
  {
    id: 503397, // data.pba_number in api/AppsManage/GetPublisherApps
    name: 'Candy Crush Saga - Ongoing', // data.pba_name in api/AppsManage/GetPublisherApps
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    Installs: 16720,
    Cost: 20,
    trends: {
      Installs: 'up',
      Cost: 'down',
    },
  },
  {
    id: 503398,
    name: 'Gardenscapes',
    image_url: 'app_img_b94a62d0-44cc-4f55-9cfd-c9b1b40b2a9a.png',
    Installs: 14280,
    Cost: 210,
    trends: {
      Installs: 'up',
      Cost: 'up',
    },
  },
  {
    id: 503399,
    name: 'Township',
    image_url: 'app_img_1df3c4c8-42e1-4cbd-91ba-b769d0bad591.png',
    Installs: 18840,
    Cost: 20,
    trends: {
      Installs: '',
      Cost: 'up',
    },
  },
  {
    id: 503400,
    name: "Lily's Garden",
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    Installs: 11920,
    Cost: 10,
    trends: {
      Installs: 'up',
      Cost: 'down',
    },
  },
  {
    id: 503401,
    name: 'Beauty Empire',
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    Installs: 15650,
    Cost: 190,
    trends: {
      Installs: 'up',
      Cost: '',
    },
  },
  {
    id: 503402,
    name: 'Royal Match',
    image_url: 'app_img_b94a62d0-44cc-4f55-9cfd-c9b1b40b2a9a.png',
    Installs: 21340,
    Cost: 160,
    trends: {
      Installs: 'up',
      Cost: 'up',
    },
  },
  {
    id: 503403,
    name: 'Homescapes',
    image_url: 'app_img_1df3c4c8-42e1-4cbd-91ba-b769d0bad591.png',
    Installs: 17680,
    Cost: 85,
    trends: {
      Installs: 'down',
      Cost: 'down',
    },
  },
  {
    id: 503404,
    name: 'Monopoly GO',
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    Installs: 24210,
    Cost: 310,
    trends: {
      Installs: 'up',
      Cost: 'up',
    },
  },
  {
    id: 503405,
    name: 'Coin Master',
    image_url: 'app_img_b94a62d0-44cc-4f55-9cfd-c9b1b40b2a9a.png',
    Installs: 19875,
    Cost: 125,
    trends: {
      Installs: 'down',
      Cost: 'up',
    },
  },
  {
    id: 503406,
    name: 'Brawl Stars',
    image_url: 'app_img_1df3c4c8-42e1-4cbd-91ba-b769d0bad591.png',
    Installs: 22150,
    Cost: 260,
    trends: {
      Installs: 'up',
      Cost: 'down',
    },
  },
  {
    id: 503407,
    name: 'Match Factory',
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    Installs: 13490,
    Cost: 75,
    trends: {
      Installs: '',
      Cost: 'up',
    },
  },
  {
    id: 503408,
    name: 'Wordscapes',
    image_url: 'app_img_b94a62d0-44cc-4f55-9cfd-c9b1b40b2a9a.png',
    Installs: 9870,
    Cost: 45,
    trends: {
      Installs: 'down',
      Cost: '',
    },
  },
  {
    id: 503409,
    name: 'Solitaire Grand Harvest',
    image_url: 'app_img_1df3c4c8-42e1-4cbd-91ba-b769d0bad591.png',
    Installs: 15240,
    Cost: 95,
    trends: {
      Installs: 'up',
      Cost: 'up',
    },
  },
  {
    id: 503410,
    name: 'Project Makeover',
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    Installs: 18430,
    Cost: 140,
    trends: {
      Installs: 'down',
      Cost: 'down',
    },
  },
  {
    id: 503411,
    name: 'Block Blast',
    image_url: 'app_img_b94a62d0-44cc-4f55-9cfd-c9b1b40b2a9a.png',
    Installs: 26780,
    Cost: 230,
    trends: {
      Installs: 'up',
      Cost: 'up',
    },
  },
];

export const MOCK_DATA_APPLICATIONS_PUBLISHER = [
  {
    id: 503397,
    name: 'Candy Crush Saga - Ongoing',
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    countries: ['Israel', 'India'],
    country_codes: ['IL', 'IN'],
    revenue: 16720,
    eCPM: 20,
    trends: {
      revenue: 'up',
      eCPM: 'down',
    },
  },
  {
    id: 503398,
    name: 'Gardenscapes',
    image_url: 'app_img_b94a62d0-44cc-4f55-9cfd-c9b1b40b2a9a.png',
    countries: ['Israel'],
    country_codes: ['IL'],
    revenue: 14280,
    eCPM: 210,
    trends: {
      revenue: 'up',
      eCPM: 'up',
    },
  },
  {
    id: 503399,
    name: 'Township',
    image_url: 'app_img_1df3c4c8-42e1-4cbd-91ba-b769d0bad591.png',
    countries: ['Israel', 'Indonesia'],
    country_codes: ['IL', 'ID'],
    revenue: 18840,
    eCPM: 20,
    trends: {
      revenue: 'down',
      eCPM: 'up',
    },
  },
  {
    id: 503400,
    name: "Lily's Garden",
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    countries: ['India'],
    country_codes: ['IN'],
    revenue: 11920,
    eCPM: 10,
    trends: {
      revenue: 'up',
      eCPM: 'down',
    },
  },
  {
    id: 503401,
    name: 'Beauty Empire',
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    countries: ['Israel', 'India'],
    country_codes: ['IL', 'IN'],
    revenue: 15650,
    eCPM: 190,
    trends: {
      revenue: 'down',
      eCPM: '',
    },
  },
  {
    id: 503402,
    name: 'Beauty Empire',
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    countries: ['Indonesia'],
    country_codes: ['ID'],
    revenue: 1550,
    eCPM: 60,
    trends: {
      revenue: 'down',
      eCPM: 'down',
    },
  },
  {
    id: 503403,
    name: "Lily's Garden",
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    countries: ['India', 'Indonesia'],
    country_codes: ['IN', 'ID'],
    revenue: 14560,
    eCPM: 34,
    trends: {
      revenue: 'up',
      eCPM: 'down',
    },
  },
];

const MOCK_DATA_EVENT_DEFINITIONS = [
  {
    id: 710007,
    name: 'purchase',
    trend: 'up',
  },
  {
    id: 710008,
    name: 'app opened',
    trend: 'up',
  },
  {
    id: 710009,
    name: 'user click on start',
    trend: 'down',
  },
  {
    id: 710010,
    name: 'payment_unique_s2s',
    trend: 'up',
  },
  {
    id: 710011,
    name: 'af_purchase',
    trend: 'up',
  },
  {
    id: 710012,
    name: 'level_completed',
    trend: 'up',
  },
  {
    id: 710013,
    name: 'tutorial_finished',
    trend: 'up',
  },
  {
    id: 710014,
    name: 'registration',
    trend: 'down',
  },
  {
    id: 710015,
    name: 'add_to_cart',
    trend: 'up',
  },
  {
    id: 710016,
    name: 'checkout_started',
    trend: 'down',
  },
  {
    id: 710017,
    name: 'subscription_started',
    trend: 'up',
  },
  {
    id: 710018,
    name: 'ad_viewed',
    trend: 'up',
  },
  {
    id: 710019,
    name: 'search',
    trend: '',
  },
  {
    id: 710020,
    name: 'share',
    trend: 'down',
  },
  {
    id: 710021,
    name: 'login',
    trend: 'up',
  },
];

const MOCK_DATA_CAMPAIGNS_DATA = [
  {
    id: 503397, // data._campaignid in /api/Campaign/GetCampaigns
    name: 'Candy Crush Saga - Ongoing', // campaign.campaign in /api/Campaign/GetCampaigns
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    status: 0,
    Installs: 16720,
    Cost: 20,
    trends: {
      Installs: 'up',
      Cost: 'down',
    },
    event_values: [0, 0, 0, 1672, 21, 26, 140, 18, 73, 12, 7, 430, 54, 9, 88],
  },
  {
    id: 503398,
    name: 'Gardenscapes',
    image_url: 'app_img_b94a62d0-44cc-4f55-9cfd-c9b1b40b2a9a.png',
    status: 3,
    Installs: 14280,
    Cost: 210,
    trends: {
      Installs: 'up',
      Cost: 'up',
    },
    event_values: [0, 7, 4532, 1, 234, 0, 84, 33, 120, 65, 3, 580, 96, 14, 102],
  },
  {
    id: 503399,
    name: 'Township',
    image_url: 'app_img_1df3c4c8-42e1-4cbd-91ba-b769d0bad591.png',
    status: 0,
    Installs: 18840,
    Cost: 20,
    trends: {
      Installs: '',
      Cost: 'up',
    },
    event_values: [0, 0, 13, 0, 23, 0, 215, 27, 64, 20, 9, 310, 41, 6, 74],
  },
  {
    id: 503400,
    name: "Lily's Garden",
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    status: 3,
    Installs: 11920,
    Cost: 10,
    trends: {
      Installs: 'up',
      Cost: 'down',
    },
    event_values: [4, 9, 0, 139, 0, 29, 101, 12, 88, 44, 2, 275, 35, 11, 69],
  },
  {
    id: 503401,
    name: 'Beauty Empire',
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    status: 0,
    Installs: 15650,
    Cost: 190,
    trends: {
      Installs: 'up',
      Cost: '',
    },
    event_values: [0, 0, 105, 2, 0, 30, 76, 25, 132, 39, 11, 390, 67, 8, 91],
  },
  {
    id: 503402,
    name: 'Royal Match',
    image_url: 'app_img_b94a62d0-44cc-4f55-9cfd-c9b1b40b2a9a.png',
    status: 0,
    Installs: 21340,
    Cost: 160,
    trends: {
      Installs: 'up',
      Cost: 'up',
    },
    event_values: [2, 11, 840, 240, 56, 18, 190, 44, 210, 72, 17, 620, 88, 15, 130],
  },
  {
    id: 503403,
    name: 'Homescapes',
    image_url: 'app_img_1df3c4c8-42e1-4cbd-91ba-b769d0bad591.png',
    status: 3,
    Installs: 17680,
    Cost: 85,
    trends: {
      Installs: 'down',
      Cost: 'down',
    },
    event_values: [1, 4, 620, 118, 33, 12, 155, 29, 95, 34, 6, 455, 52, 7, 83],
  },
  {
    id: 503404,
    name: 'Monopoly GO',
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    status: 0,
    Installs: 24210,
    Cost: 310,
    trends: {
      Installs: 'up',
      Cost: 'up',
    },
    event_values: [8, 15, 1180, 310, 72, 41, 260, 61, 245, 98, 24, 810, 112, 22, 165],
  },
  {
    id: 503405,
    name: 'Coin Master',
    image_url: 'app_img_b94a62d0-44cc-4f55-9cfd-c9b1b40b2a9a.png',
    status: 3,
    Installs: 19875,
    Cost: 125,
    trends: {
      Installs: 'down',
      Cost: 'up',
    },
    event_values: [3, 6, 730, 95, 47, 16, 175, 38, 160, 58, 12, 540, 73, 13, 119],
  },
  {
    id: 503406,
    name: 'Brawl Stars',
    image_url: 'app_img_1df3c4c8-42e1-4cbd-91ba-b769d0bad591.png',
    status: 0,
    Installs: 22150,
    Cost: 260,
    trends: {
      Installs: 'up',
      Cost: 'down',
    },
    event_values: [5, 12, 960, 180, 64, 35, 240, 52, 188, 86, 20, 705, 101, 19, 148],
  },
  {
    id: 503407,
    name: 'Match Factory',
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    status: 0,
    Installs: 13490,
    Cost: 75,
    trends: {
      Installs: '',
      Cost: 'up',
    },
    event_values: [0, 3, 410, 64, 18, 9, 120, 21, 72, 27, 4, 330, 46, 5, 70],
  },
  {
    id: 503408,
    name: 'Wordscapes',
    image_url: 'app_img_b94a62d0-44cc-4f55-9cfd-c9b1b40b2a9a.png',
    status: 3,
    Installs: 9870,
    Cost: 45,
    trends: {
      Installs: 'down',
      Cost: '',
    },
    event_values: [0, 2, 250, 31, 9, 5, 98, 17, 44, 15, 1, 215, 29, 3, 58],
  },
  {
    id: 503409,
    name: 'Solitaire Grand Harvest',
    image_url: 'app_img_1df3c4c8-42e1-4cbd-91ba-b769d0bad591.png',
    status: 0,
    Installs: 15240,
    Cost: 95,
    trends: {
      Installs: 'up',
      Cost: 'up',
    },
    event_values: [2, 5, 540, 87, 26, 14, 142, 32, 110, 41, 8, 470, 61, 10, 94],
  },
  {
    id: 503410,
    name: 'Project Makeover',
    image_url: 'app_img_82192951-5df0-4c31-a372-bf81b0878bb5.png',
    status: 3,
    Installs: 18430,
    Cost: 140,
    trends: {
      Installs: 'down',
      Cost: 'down',
    },
    event_values: [1, 7, 675, 122, 39, 19, 168, 36, 138, 49, 10, 520, 70, 12, 107],
  },
  {
    id: 503411,
    name: 'Block Blast',
    image_url: 'app_img_b94a62d0-44cc-4f55-9cfd-c9b1b40b2a9a.png',
    status: 0,
    Installs: 26780,
    Cost: 230,
    trends: {
      Installs: 'up',
      Cost: 'up',
    },
    event_values: [6, 18, 1320, 405, 91, 48, 310, 75, 280, 116, 31, 920, 124, 28, 190],
  },
];

export const MOCK_DATA_CAMPAIGNS_AND_EVENTS = {
  event_ids: MOCK_DATA_EVENT_DEFINITIONS.map(({ id }) => id),
  event_titles: MOCK_DATA_EVENT_DEFINITIONS.map(({ name }) => name),
  campaigns_data: MOCK_DATA_CAMPAIGNS_DATA,
};

export const MOCK_DATA_TOP_EVENTS = MOCK_DATA_EVENT_DEFINITIONS.map((event, eventIndex) => ({
  ...event,
  value: MOCK_DATA_CAMPAIGNS_DATA.reduce(
    (sum, campaign) => sum + (campaign.event_values[eventIndex] || 0),
    0,
  ),
}));
